import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'modal-search-filter',
  templateUrl: './modal-search-filter.component.html',
  styleUrls: ['./modal-search-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalSearchFilterComponent implements OnInit {

    @ViewChild('modalSearchFilter') public modalSearchFilter: NgbModal;

  closeResult: string;
  modalReference: NgbModalRef;

  @Input() title: string = 'FILTERS';
  @Input() applyText: string ='APPLY';
  @Output() userSelection:EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    private modalService: NgbModal
  ) { }

  public apply(): void {
    this.userSelection.emit(true);
    }

  public cancel(): void {
      this.userSelection.emit(false);
    }
  

  public openSearchFilterModal() {
    this.modalReference= this.modalService.open(
      this.modalSearchFilter, {
        windowClass: 'modal-search-filter',
        size: 'lg',
        keyboard: false,
        backdrop: false,
        centered: true
      }
    );
  }

  public closeSearchFilterModal() {
      this.modalReference.close();
  }


  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/modal-search-filter/modal-search-filter.component.ts